module.exports = __webpack_public_path__ + "static/waltz_kore_za_tortu_3-6a24e1b9eb8d99857a236195025d82c8.jpg";